const rankingItems = [
  { rank: 1, title: '狂飙', heat: '9.8', tag: '刑侦', trend: 'up', desc: '张译张颂文演技巅峰对决' },
  { rank: 2, title: '繁花', heat: '9.7', tag: '年代', trend: 'up', desc: '王家卫首部电视剧作品' },
  { rank: 3, title: '庆余年第二季', heat: '9.6', tag: '古装', trend: 'up', desc: '范闲归来再掀权谋风暴' },
  { rank: 4, title: '长相思', heat: '9.5', tag: '仙侠', trend: 'stable', desc: '杨紫领衔上古虐恋传奇' },
  { rank: 5, title: '长安十二时辰', heat: '9.4', tag: '古装', trend: 'stable', desc: '全景还原盛世大唐风貌' },
  { rank: 6, title: '三体', heat: '9.3', tag: '科幻', trend: 'up', desc: '刘慈欣科幻巨制真人版' },
  { rank: 7, title: '漫长的季节', heat: '9.2', tag: '悬疑', trend: 'up', desc: '东北小城跨越二十年的秘密' },
];

export default function Ranking() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            热播榜单
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            全网热播剧集实时排行，看看大家都在追什么
          </p>
        </div>

        <div className="max-w-3xl mx-auto bg-background-50 rounded-xl border border-background-200/70 overflow-hidden">
          {rankingItems.map((item, idx) => (
            <div
              key={item.rank}
              className={`flex items-center gap-3 md:gap-4 px-4 md:px-6 py-3.5 md:py-4 ${
                idx < rankingItems.length - 1 ? 'border-b border-background-200/70' : ''
              } hover:bg-background-100 transition-colors cursor-pointer`}
            >
              <span
                className={`w-7 h-7 flex items-center justify-center rounded-full text-xs font-bold flex-shrink-0 ${
                  item.rank <= 3
                    ? 'bg-primary-500 text-white'
                    : 'bg-secondary-100 text-secondary-700'
                }`}
              >
                {item.rank}
              </span>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-0.5">
                  <h3 className="text-sm md:text-base font-medium text-foreground-800 whitespace-nowrap">
                    {item.title}
                  </h3>
                  <span className="px-1.5 py-0.5 bg-accent-50 text-accent-700 text-xs rounded whitespace-nowrap">
                    {item.tag}
                  </span>
                  {item.trend === 'up' && (
                    <i className="ri-arrow-up-line text-accent-500 text-xs"></i>
                  )}
                </div>
                <p className="text-xs text-foreground-500 truncate">{item.desc}</p>
              </div>
              <div className="flex items-center gap-1 flex-shrink-0">
                <i className="ri-fire-line text-accent-500 text-sm"></i>
                <span className="text-sm font-medium text-accent-600 whitespace-nowrap">{item.heat}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}